import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import projectsReducer from '../scenes/projects/data/reducer';
import analysisProjectsReducer from '../scenes/analysis/data/reducer';

import { SET_ACTIVE_SECTION, SET_ALERTS, SET_AUTH_USER } from './actions';

const appInitialState = { loading: false, section: null, alerts: [], user: null };

const appReducer = (state = appInitialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SECTION:
      return { ...state, section: action.section };
    case SET_ALERTS:
      return { ...state, alerts: action.alerts };
    case SET_AUTH_USER:
      return { ...state, user: action.user };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  app: appReducer,
  projects: projectsReducer,
  analysis: analysisProjectsReducer,
  form: formReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/data/reducer.js